<template>
  <v-container
    fill-height
    fluid
  >
    <v-layout
      justify-center
      align-center
    >
      <v-flex xs12>
        <v-card-text>
          <h2 class="font-weight-light mb-4">Pay Bill <span v-if="this.$props.forceSandbox">Sandbox</span></h2>

          <v-container
            class="pa-0"
            grid-list-xl
            fluid
          >
            <div>
              <v-flex
                xs12
                md6
              >
                <v-text-field
                  v-model="accountNumber"
                  label="Account Number"
                  :rules="[
                    () => !!accountNumber || 'This field is required',
                  ]"
                  placeholder="1234"
                  class="purple-input"
                  required
                />

                <v-text-field
                  v-model="amount"
                  label="Amount"
                  :rules="[
                    () => !!amount || 'This field is required',
                    () => isNumeric(amount) || 'Field must be a number'
                  ]"
                  placeholder="0.00"
                  prefix="$"
                  class="purple-input"
                  required
                />
              </v-flex>
            </div>
            <br>
            <paypal-checkout
              v-if="this.$props.forceSandbox"
              key="sandboxed"
              :amount="amount"
              :invoice-number="accountNumber"
              currency="USD"
              :client="paypal"
              env="sandbox"
              :button-style="buttonStyle"
              :debug="true"
              v-on:payment-authorized="paymentAuthorized"
              v-on:payment-completed="paymentCompleted"
              v-on:payment-cancelled="paymentCancelled"
              v-on:payment-error="paymentError"
            />
            <paypal-checkout
              v-else
              key="normal"
              :amount="amount"
              :invoice-number="accountNumber"
              currency="USD"
              :client="paypal"
              :env="environment"
              :button-style="buttonStyle"
              v-on:payment-authorized="paymentAuthorized"
              v-on:payment-completed="paymentCompleted"
              v-on:payment-cancelled="paymentCancelled"
              v-on:payment-error="paymentError"
            />
          </v-container>
        </v-card-text>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    forceSandbox: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  data: () => ({
    amount: '',
    accountNumber: '',

    environment: process.env.VUE_APP_PAYPAL_ENV || 'sandbox',
    paypal: {
      sandbox: process.env.VUE_APP_PAYPAL_CREDS_SANDBOX,
      production: process.env.VUE_APP_PAYPAL_CREDS_PRODUCTION
    },
    buttonStyle: {
      label: 'pay',
      size: 'medium',
      shape: 'pill',
      color: 'gold',
      fundingicons: 'true'
    }
  }),
  methods: {
    isNumeric: function (num) {
      return parseFloat(num) == num // eslint-disable-line eqeqeq
    },

    paymentAuthorized: function (_data) {
    },
    paymentCompleted: function (_data) {
      alert('Payment completed successfully')
    },
    paymentCancelled: function (_data) {
      alert('Payment cancelled')
    },
    paymentError: function (err) {
      console.error('PaymentError:', err)
      alert(`Error completing payment. Please try again.`)
    }
  }
}
</script>

<style lang="scss">
</style>
